import { createRef } from 'react';

import { DidomiInstance } from 'services/consents-management/DidomiSDK/types';

export const DidomiRef = createRef<DidomiInstance>();
